module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Difference-053d59f7dd040607798cd718855d7531.svg";